module.exports = __webpack_public_path__ + "img/ff_2.a4041a7f.png";